import { util } from "@/common/theme";
import BorderedIcon from "@/components/BorderedIcon";
import CustomSplitText from "@/mono/components/CustomSplitText";
import ShuffledText from "@/mono/components/ShuffledText";
import styled from "styled-components";

import WhatWeDoServiceHeader from "../WhatWeDoHeader";
import ColumnRow, { columnRowTypeNames } from "../../contentSections/ColumnRow";
import { TransitionLink } from "mono/components/TransitionLink";

export default function WhatWeDoServiceStrategy() {
  return (
    <Wrapper>
      <WhatWeDoServiceHeader service="Strategy">
        <div className="what-we-do__strategy-top-inner">
          <CustomSplitText tag="p">
            Bij Nine ontwikkelen we merkstrategieën die richting geven, focus
            brengen en zorgen voor blijvend succes. Met diepgaand onderzoek, een
            heldere positionering en een concreet actieplan helpen we jouw merk
            groeien, relevant blijven en zich onderscheiden van de concurrentie.
          </CustomSplitText>
          {/* <ShuffledText
            animateOnScroll
            text="Velit sint id sunt elit laborum ipsum tempor."
          ></ShuffledText> */}
        </div>
      </WhatWeDoServiceHeader>

      <ColumnRow
        data={{
          columns: [
            // {
            //   __typename: columnRowTypeNames.image,
            //   image: {
            //     url: "https://picsum.photos/seed/1/1600/900",
            //   },
            //   width: 70,
            // },
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/strategy.jpeg",
              },
              width: 100,
            },
          ],
        }}
      />

      <StrategyText>
        <div className="strategy-text__inner">
          <CustomSplitText tag="p">
            Geen dikke rapporten die in de la belanden, maar een strategie die
            meteen toepasbaar is en meetbaar resultaat oplevert. Zo bouw je
            vandaag aan de toekomst van jouw merk.
          </CustomSplitText>
          <TransitionLink href="/service/strategy">
            <BorderedIcon
              text={"More about <strong>strategy</strong>"}
            ></BorderedIcon>
          </TransitionLink>
        </div>
      </StrategyText>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .what-we-do__strategy-top-inner {
    display: flex;
    position: relative;

    .txt-shuffle-wrapper {
      bottom: 0;
      right: 30%;
    }
  }

  margin-bottom: 150rem;
`;

const StrategyText = styled.div`
  ${util.inner}

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 280rem !important;

  .strategy-text__inner {
    .icon-container {
      margin-top: 100rem;
    }
    max-width: 2000rem;
  }
`;
